export const getOs = () => {
  const os = [
    'Windows',
    'Mac',
    'Linux',
    'Android',
    'iOS',
    'iPadOS',
    'Chrome OS',
    'Unix',
  ]

  return os.find((v) => window?.navigator.userAgent.includes(v)) || 'UnknownOS'
}
